"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataBooleanVisitor = void 0;
const odata_expression_visitor_1 = require("./odata-expression-visitor");
/**
 * Visits every node in an AST and return a boolean
 *
 * @class ODataBooleanVisitor
 * @extends ODataExpressionVisitor
 */
class ODataBooleanVisitor extends odata_expression_visitor_1.ODataExpressionVisitor {
    constructor(target) {
        super();
        this.target = target;
        this.visitPropertyNode = this.visitPropertyNode.bind(this);
        this.visitLiteralNode = this.visitLiteralNode.bind(this);
        this.visitFunctionCallNode = this.visitFunctionCallNode.bind(this);
        this.visitBinaryExpressionNode = this.visitBinaryExpressionNode.bind(this);
        this.visitConditionalNode = this.visitConditionalNode.bind(this);
    }
    visitPropertyNode(node) {
        return this.target?.[node.name];
    }
    visitLiteralNode(node) {
        let value = node.value;
        if (value instanceof Array && value[0] === 'null') {
            value = null;
        }
        return value;
    }
    visitFunctionCallNode(node) {
        for (const arg of node.args) {
            this.visit(arg);
            this.visit(arg);
        }
        return false;
    }
    visitBinaryExpressionNode(node) {
        if (node.type === 'or') {
            return this.visit(node.left) || this.visit(node.right);
        }
        return this.visit(node.left) && this.visit(node.right);
    }
    visitConditionalNode(node) {
        switch (node.type) {
            case 'gt':
                return this.visit(node.left) > this.visit(node.right);
            case 'ge':
                return this.visit(node.left) >= this.visit(node.right);
            case 'lt':
                return this.visit(node.left) < this.visit(node.right);
            case 'le':
                return this.visit(node.left) <= this.visit(node.right);
            case 'eq':
                return this.visit(node.left) == this.visit(node.right);
            case 'ne':
                return this.visit(node.left) != this.visit(node.right);
        }
    }
}
exports.ODataBooleanVisitor = ODataBooleanVisitor;
//# sourceMappingURL=odata-boolean-visitor.js.map